import { Button, Checkbox, DatePicker, Form, Input, Modal, Select, Space } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { Fragment, useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { baseAxiosComplete, baseAxiosNoInfo } from '../../tool/axios'
import './checkInMangeDetail.css'
import BabyInfo from './components/BabyInfo'
import CheckInRecord from './components/CheckInRecord'
import CllientInfo from './components/CllientInfo'
import ProjectRecord from './components/ProjectRecord'
import Waiter from './components/Waiter'

const {Option} = Select

interface Client {
    check_in_id: string //入住id
    check_in_user_name: string //客人姓名
    check_in_phone: string //手机号码
    preg_status_desc: string //怀孕时期
    expect_born_day: string //预产期（预计入住时间）
    actually_born_day: string //分娩日
    check_in_time: string //实际入住时间
    check_out_time_init: string //预计出所时间
    check_out_time_finally: string //实际出所时间
    emergency_man_name: string //紧急联系人
    emergency_phone: string //紧急联系人手机号
    accompany_man_name: string //陪护人
    accompany_phone: string //陪护人手机号
    deal_item_name: string //签单套餐名称
    check_in_total_days: number //入住总天数，整数类型
    check_in_already_days: number //已入住天数，整数类型
    check_in_left_days: number //剩余天数，整数类型
    item_days: number //套餐入住天数，整数类型
    gift_days: number //赠送天数，整数类型
    deal_records_remark: string //签单备注
    store_id: string //签单门店id
    deal_prov_pic_list: string //合同凭证图片
    already_notify: number // 是否通知入住 0未通知 1已通知，整数类型，当为1时候前端点击“通知入住”需要调用“入住客户管理-已预订-查询通知信息”接口填充各个字段且禁用各个字段
    check_in_status: number  //0待分配 1已预订 2已入住 3已出所
    current_room_number: string // 当前入住房号，可能为空
}
interface checkInRecordData {
    room_number: string,
    check_in_day_range: string,
    room_type_name: string
}

interface person {
    check_in_id: string
    belong_minion_id: string//责任管家id
    belong_minion_name: string, // 责任管家名称
    belong_cleaner_id: string, // 生活助理（保洁）id
    belong_cleaner_name: string, // 生活助理（保洁）名称
    belong_nurse_id: string, // 责任护士id
    belong_nurse_name: string, // 责任护士名称，冗余字段
    belong_dietician_id: string, // 营养师id
    belong_dietician_name: string, // 营养师名称
    belong_recover_id: string, // 产康师id
    belong_recover_name: string, // 产康师名称
    belong_look_after_id: string, // 护理师id
    belong_look_after_name: string, // 护理师名称
}
interface ep {
    "employee_id": string,
    "user_name": string
}
export default function () {

    const [tabCurrent, setTabCurrent] = useState<number>(0)
    const [clientData, setClientData] = useState<Client>()
    const param: { id: string } = useParams()
    const [statusStr, setStatusStr] = useState<string>('')
    const [checkInRecordData, setCheckInRecordData] = useState<checkInRecordData[]>([])
    const [servicedata, setServiceData] = useState<person>()
    const [hasServiceEmployee, setHasServiceEmployee] = useState<number>(0)
    const [visible2, setVisible2] = useState<boolean>(false)
    const [form] = useForm()
    const [ep35Data,setEp35Data] = useState<ep[]>([])

    const getServiceInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/service_employee_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            res && setServiceData(res)
        })
    }

    const getCheckInRecord = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/room_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                setCheckInRecordData(res)
            }
        })
    }

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                switch (res.check_in_status) {
                    case 0:
                        setStatusStr('待分配')
                        break
                    case 1:
                        setStatusStr('已预订')
                        break
                    case 2:
                        setStatusStr('已入住')
                        break
                    case 3:
                        setStatusStr('已出所')
                        break
                    case 4:
                        setStatusStr('续住中')
                        break
                }
                setClientData(res)
                
                baseAxiosNoInfo('/global/employee_list_by_position',{params:{
                    department_id: res.store_id,
                    position_number:35
                }}).then((res:any)=>{
                    res && setEp35Data(res)
                })
            }
        })
    }

    useEffect(() => {
        getClientInfo()
        getCheckInRecord()
        getServiceInfo()
        
    }, [])
    const formItemLayout = {
        labelCol: { span: 7 },
        wrapperCol: { span: 14 }
    }
    

    return <div className="common-level2-edit h-detail">
        <p className="modules-h2">护理中心-查看客户记录</p>

        <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
            <Button size="small" onClick={() => { window.history.go(-1) }} >返回</Button>
        </div>

        <Space style={{paddingLeft:20,marginBottom:20}}>
            <Button type="primary" size="small" onClick={()=>{
                setVisible2(true)
            }}>记录项目护理</Button>
        </Space>

        <CllientInfo status={statusStr} data={clientData} />
        {clientData?.check_in_status !== 0 && <CheckInRecord data={checkInRecordData} />}
        <BabyInfo />

        {/* 初次分配服务人员 */}
        <Waiter serviceData={servicedata} storeID={clientData?.store_id} onChange={() => {
            getClientInfo()
            getCheckInRecord()
            getServiceInfo()
        }} />


        {(clientData?.check_in_status == 2 || clientData?.check_in_status == 3) && <Fragment>
            <div className="tab clear">
                <div className={tabCurrent === 0 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(0) }}>项目护理记录</div>
            </div>
            <div className="tab-cont">
                {tabCurrent === 0 ? <div className="cont">
                    <ProjectRecord />
                </div> : null}
            </div></Fragment>}

            <Modal title="记录项目护理" visible={visible2} onCancel={() => { setVisible2(false) }} footer={false}>
            <Form  {...formItemLayout} form={form} onFinish={(values:any)=>{
                baseAxiosComplete.post('/nursing/customer/detail/add_item_nursing', {
                    check_in_id:param.id,
                    nurse_id:values.nurse_id,
                    nursing_time:values.nursing_time.format('YYYY-MM-DD hh:mm:ss'),
                    nursing_care_item:values.nursing_care_item.join(','),
                    baby_weight:values.baby_weight,
                    nursing_records:values.nursing_records,
                }).then(res => {
                    if (res.status === 0){
                        setVisible2(false)
                        // if(prop.onChange) prop.onChange()
                    }
                })
            }}>
                <Form.Item label="护士" name="nurse_id" >
                    <Select  virtual={false}>
                        {ep35Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="护理时间" name="nursing_time" >
                    <DatePicker showTime  />
                </Form.Item>
                <Form.Item label="护理项目" name="nursing_care_item" >
                {/* 1宝宝洗澡 2宝宝早教 3宝宝抚触 4宝妈伤口护理 5宝宝游泳 6宝妈洗头/洗澡 */}
                <   Checkbox.Group options={[
                    {value:1,label:'宝宝洗澡'},
                    {value:2,label:'宝宝早教'},
                    {value:3,label:'宝宝抚触'},
                    {value:4,label:'宝妈伤口护理'},
                    {value:5,label:'宝宝游泳'},
                    {value:6,label:'宝妈洗头/洗澡'},
                ]}  />
                </Form.Item>
                <Form.Item label="宝宝体重(单位g)" name="baby_weight" >
                    <Input/>
                </Form.Item>
                <Form.Item label="护理记录" name="nursing_records" >
                    <Input/>
                </Form.Item>
                
                {/* <Form.Item label="责任护士" name="belong_nurse_id" >
                    <Select virtual={false}>
                        {ep35Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="营养师" name="belong_dietician_id" >
                    <Select virtual={false}>
                        {ep36Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="产康师" name="belong_recover_id" >
                    <Select virtual={false}>
                        {ep37Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="护理师" name="belong_look_after_id" >
                    <Select virtual={false}>
                        {ep38Data.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item> */}
                <Form.Item wrapperCol={{ span: 12, offset: 7 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>
}